/*
 * MarketPage Messages
 *
 * This contains all the text for the MarketPage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LandingPage.Referral';

export default defineMessages({
  heroTitle: {
    id: `${scope}.heroTitle`,
    defaultMessage: 'Giới thiệu bạn bè – Cùng nhận voucher mua hàng F&B',
  },
  heroSubtitle: {
    id: `${scope}.heroSubtitle`,
    defaultMessage: 'Thực hiện nhiệm vụ mời bạn để nhận nhiều phần quà, voucher hấp dẫn.',
  },
  joinNow: {
    id: `${scope}.joinNow`,
    defaultMessage: 'Tham gia ngay',
  },
  rewardsSectionTitle: {
    id: `${scope}.rewardsSectionTitle`,
    defaultMessage: 'Lợi ích của chương trình giới thiệu',
  },
  referrerTitle: {
    id: `${scope}.referrerTitle`,
    defaultMessage: 'Người giới thiệu',
  },
  referrerDesc: {
    id: `${scope}.referrerDesc`,
    defaultMessage:
      'Nhận thưởng 500.000đ (05 voucher trị giá 100.000đ) khi bạn bè hoàn tất đơn hàng đầu tiên (giao thành công, không huỷ/trả).',
  },
  refereeTitle: {
    id: `${scope}.refereeTitle`,
    defaultMessage: 'Người được giới thiệu',
  },
  refereeDesc: {
    id: `${scope}.refereeDesc`,
    defaultMessage:
      'Nhận voucher mua hàng trị giá 100.000đ khi hoàn thành đơn hàng đầu tiên sau khi đăng ký trở thành khách hàng Kamereo qua link/mã giới thiệu.',
  },
  extraGiftTitle: {
    id: `${scope}.extraGiftTitle`,
    defaultMessage: 'Thêm quà cho người mới',
  },
  extraGiftDesc: {
    id: `${scope}.extraGiftDesc`,
    defaultMessage: 'Nhận thêm set quà tặng 8 món hấp dẫn khi trở thành khách hàng mới của Kamereo.',
  },
  howToTitle: {
    id: `${scope}.howToTitle`,
    defaultMessage: 'Hướng dẫn cách tham gia',
  },
  viewTerms: {
    id: `${scope}.viewTerms`,
    defaultMessage: 'Xem điều kiện và điều khoản',
  },
  tabReferrer: {
    id: `${scope}.tabReferrer`,
    defaultMessage: 'Người giới thiệu',
  },
  tabReferee: {
    id: `${scope}.tabReferee`,
    defaultMessage: 'Người được giới thiệu',
  },
  step1Title: {
    id: `${scope}.step1Title`,
    defaultMessage: 'Bước 1',
  },
  step1Desc: {
    id: `${scope}.step1Desc`,
    defaultMessage: 'Đăng nhập vào ứng dụng Kamereo hoặc truy cập trang web chính thức của Kamereo.',
  },
  step2Title: {
    id: `${scope}.step2Title`,
    defaultMessage: 'Bước 2',
  },
  step2Desc: {
    id: `${scope}.step2Desc`,
    defaultMessage:
      'Truy cập vào mục "Giới thiệu bạn bè" để lấy Mã giới thiệu duy nhất hoặc đường dẫn (link) giới thiệu cá nhân.',
  },
  step3Title: {
    id: `${scope}.step3Title`,
    defaultMessage: 'Bước 3',
  },
  step3Desc: {
    id: `${scope}.step3Desc`,
    defaultMessage:
      'Chia sẻ mã giới thiệu hoặc đường dẫn này cho bạn bè, đối tác là các đơn vị kinh doanh chưa từng sử dụng dịch vụ của Kamereo.',
  },
  faqTitle: {
    id: `${scope}.faqTitle`,
    defaultMessage: 'Câu hỏi thường gặp',
  },
  faq1Question: {
    id: `${scope}.faq1Question`,
    defaultMessage: '1. Tôi cần điều kiện gì để tham gia chương trình Giới thiệu bạn bè?',
  },
  faq2Question: {
    id: `${scope}.faq2Question`,
    defaultMessage: '2. Đối tượng tham gia chương trình?',
  },
  faq3Question: {
    id: `${scope}.faq3Question`,
    defaultMessage: '3. Tôi có thể mời tối đa bao nhiêu người tham gia?',
  },
  faq4Question: {
    id: `${scope}.faq4Question`,
    defaultMessage: '4. Khi nào tôi nhận được quà tặng?',
  },
  faq5Question: {
    id: `${scope}.faq5Question`,
    defaultMessage: '5. Tôi có thể xem danh sách những người đã dùng mã giới thiệu của mình không?',
  },
  faq6Question: {
    id: `${scope}.faq6Question`,
    defaultMessage: '6. Tôi phải làm gì nếu đã giới thiệu thành công nhưng chưa nhận được thưởng?',
  },
  faq1Answer: {
    id: `${scope}.faq1Answer`,
    defaultMessage:
      'Bạn chỉ cần:\n• Có tài khoản Kamereo đã đăng ký\n• Là khách hàng hiện tại đang mua hàng tại Kamereo\nSau đó, bạn có thể lấy mã giới thiệu (referral code) ngay trong tài khoản và bắt đầu chia sẻ.',
  },
  faq2Answer: {
    id: `${scope}.faq2Answer`,
    defaultMessage:
      '• <strong>Người giới thiệu (Referrer)</strong>: Khách hàng hiện tại của Kamereo\n• <strong>Người được giới thiệu (Referee)</strong>: Doanh nghiệp F&B, chưa từng mua hàng trên hệ thống Kamereo',
  },
  faq3Answer: {
    id: `${scope}.faq3Answer`,
    defaultMessage: 'Không giới hạn số lượt mời bạn mới.\nBạn càng giới thiệu nhiều, cơ hội nhận thưởng càng cao.',
  },
  faq4Answer: {
    id: `${scope}.faq4Answer`,
    defaultMessage:
      'Bạn sẽ nhận thưởng khi:\n• Người được giới thiệu đăng ký tài khoản thành công và hoàn tất đơn hàng đầu tiên.\n• Thời gian xác nhận và trao thưởng: trong vòng 7–10 ngày làm việc.',
  },
  faq5Answer: {
    id: `${scope}.faq5Answer`,
    defaultMessage:
      'Có. Bạn có thể theo dõi tại:\n• Danh sách người đã đăng ký bằng mã của bạn hoặc tại trang danh mục "Giới thiệu bạn bè" của bạn.\n• Trạng thái từng người: Đã đăng ký / Đã có tài khoản / Đã mua hàng / Đã xác thực / Đã phát thưởng / Đã từ chối',
  },
  faq6Answer: {
    id: `${scope}.faq6Answer`,
    defaultMessage:
      'Bạn có thể:\n• Kiểm tra lại trạng thái tại trang Bảng theo dõi Giới thiệu bạn bè\n• Đảm bảo người được giới thiệu đã hoàn tất đơn hàng hợp lệ\n• Liên hệ CSKH nếu sau 14 ngày vẫn chưa nhận thưởng',
  },
  refereeStep1Desc: {
    id: `${scope}.refereeStep1Desc`,
    defaultMessage: 'Tải ứng dụng Kamereo hoặc truy cập đường dẫn được chia sẻ từ Người giới thiệu.',
  },
  refereeStep2Desc: {
    id: `${scope}.refereeStep2Desc`,
    defaultMessage:
      'Thực hiện đăng ký tạo tài khoản và nhập chính xác mã giới thiệu của người giới thiệu trong đơn đăng ký.',
  },
  refereeStep3Desc: {
    id: `${scope}.refereeStep3Desc`,
    defaultMessage: 'Người được giới thiệu hoàn tất đơn đầu tiên (giao thành công, không huỷ/trả).',
  },
});
